import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

// CRA style (this project uses react-scripts). Avoid import.meta in tests to prevent parse errors.
let supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string | undefined;
let supabasePublishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY as string | undefined;

// In test environment, provide safe defaults so imports don't throw
if ((!supabaseUrl || !supabasePublishableKey) && process.env.NODE_ENV === 'test') {
  supabaseUrl = 'http://localhost';
  supabasePublishableKey = 'test-key';
}

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error(
    'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY in tutor-frontend/.env.local.'
  );
}

console.log('Initializing Supabase with URL:', supabaseUrl);

// Create a single supabase client for interacting with your database
export const supabase = createClient<Database>(supabaseUrl, supabasePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
